import { DataList, DataListItem } from '@app/components/DataList'
import ExpandableContent from '@app/components/ExpandableContent'
import SpaceEditorModal from '@app/components/SpaceEditorModal'
import { ISpace } from '@app/models/Space'
import { bindFunctions } from '@app/utils/class'
import { formatNumber } from '@app/utils/formatting'
import * as React from 'react'
import { Card, CardBody, CardTitle } from 'reactstrap'

interface ISpaceCardProps {
  actions?: React.ReactNode
  className?: string
  editModalOpen?: any
  onCancelClicked?: () => void
  onOkClicked?: (e: ISpace) => void
  propertyId?: string
  space: ISpace
  style?: React.CSSProperties
}

export default class SpaceCard extends React.PureComponent<ISpaceCardProps> {
  constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <Card className={this.props.className} style={this.props.style}>
        <CardBody>
          <div className='d-flex justify-content-between'>
            <CardTitle>Space: {this.props.space.spaceNo}</CardTitle>
            <div> {this.props.actions} </div>
          </div>
          <SpaceEditorModal
            isOpen={this.props.editModalOpen || false}
            space={this.props.space}
            onConfirmClick={this._onOkClicked}
            onCancelClick={this._onCancelClicked}
          />
          <DataList>
            <DataListItem
              label='Space Available'
              value={this.props.space.spaceAvailable.toString()}
            />
            <DataListItem
              label='Minimum Divisible'
              value={formatNumber(this.props.space.minDivisible, 0)}
              visible={this.props.space.minDivisible > 0}
            />
            <DataListItem
              label='Maximum Contiguous'
              value={formatNumber(this.props.space.maxContiguous, 0)}
              visible={this.props.space.maxContiguous > 0}
            />
            <DataListItem
              label='Dock High Doors'
              value={this.props.space.noOfDockHighDoorsLoading}
              visible={this.props.space.noOfDockHighDoorsLoading > 0}
            />
            <DataListItem
              label='Drive in Doors'
              value={this.props.space.noOfDriveInGradeLevelDoors}
              visible={this.props.space.noOfDriveInGradeLevelDoors > 0}
            />
            <DataListItem
              label='Ceiling Height'
              value={`${this.props.space.ceilingHeight} FT`}
              visible={this.props.space.ceilingHeight > 0}
            />
            <DataListItem
              label='Parking Spaces'
              value={this.props.space.noOfParkingSpaces}
              visible={this.props.space.noOfParkingSpaces > 0}
            />
            <DataListItem
              label='Office Space'
              value={`${formatNumber(this.props.space.officeSF)} SF`}
              visible={this.props.space.officeSF > 0}
            />
          </DataList>
          {this.props.space.spaceDescription && (
            <div className='mt-2'>
              <div>Description</div>
              <ExpandableContent>
                <div className='white-space-pre'>
                  {this.props.space.spaceDescription}
                </div>
              </ExpandableContent>
            </div>
          )}
        </CardBody>
      </Card>
    )
  }

  private _onCancelClicked() {
    if (this.props.onCancelClicked) {
      this.props.onCancelClicked()
    }
  }

  private _onOkClicked(value: ISpace) {
    if (this.props.onOkClicked) {
      this.props.onOkClicked(value)
    }
  }
}
